import styled from "styled-components"

export const InputWrapper = styled.div`
    width: 100%;
    div{
        position: relative;
    }
    input{
        width: 100%;
        padding: 6px 12px;
        border-radius: 4px;
        height: 42px;
        &:focus{
            box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 25%);
        }
    }
    .input_password{
        padding-right: 45px;
    }
    .eye_icon{
        position: absolute;
        right: 15px;
        width: 20px;
        height: 20px;
        top: 50%;
        transform: translateY(-50%);
    }
`
